const snakeToKebabCase = value => (value ? value.toLowerCase().replace(/_/g, '-') : '');

export default snakeToKebabCase;
